import { Form } from 'antd';
import { uniqBy } from 'lodash';
import { ReactNode } from 'react';

import { ConsoleDrawer } from '../../../components/drawer';
import { ConsoleForm } from '../../../components/form';

import { getLocalTime, strToJson } from '../../../lib';

import { IPageGameManageEnvItem, IPageGameManageItem } from '../../../model';

import { renderEnvTaskStatus, renderEnvTypeTag } from '../../lib';
import { getEnvNameByValue } from '../../utils/env';
import { SubServiceChoose } from '../close-open/sub-service-choose';
import { getUserNameBySite } from '../lib/columns';
import { IAPIUserInfo } from '../../../model/api-modules';

export interface IDetailConfig {
  label: string;
  splitColumnNum?: number;
  items?: {
    label: string;
    value?: ReactNode;
  }[];

  customRender?: () => ReactNode;
}

export const openDetail = (title: string, config: IDetailConfig[]) => {
  const getForm = () => {
    return (
      <ConsoleForm>
        {config.map((configItem) => {
          const { splitColumnNum = 1 } = configItem;
          return (
            <>
              <label>{configItem.label}</label>
              <div
                style={{
                  display: 'grid',
                  gridTemplateColumns: new Array(splitColumnNum)
                    .fill('1fr')
                    .join(' '),
                }}
              >
                {configItem.items?.map((column) => {
                  return (
                    <Form.Item label={column.label}>{column.value}</Form.Item>
                  );
                }) || ''}
              </div>
              {configItem.customRender?.() || ''}
            </>
          );
        })}
      </ConsoleForm>
    );
  };

  return ConsoleDrawer.show({
    title,
    hideFooter: true,
    children: getForm(),
  });
};

export const openEnvDetail = (
  record: IPageGameManageEnvItem,
  gameInfo: IPageGameManageItem,
  userInfo: IAPIUserInfo | null,
  site?: string,
  onChange?: () => void
) => {
  openDetail('环境详情', [
    {
      label: '基础信息',
      splitColumnNum: 2,
      items: [
        {
          label: '环境名称',
          value: (
            <span>
              {record.Name}
              {renderEnvTypeTag(record.Type)}
            </span>
          ),
        },
        {
          label: '环境ID',
          value: record.id,
        },
        {
          label: 'EnvID',
          value: record.Guid,
        },
        {
          label: '状态',
          value: renderEnvTaskStatus(record.task),
        },
        {
          label: '地区',
          value: getEnvNameByValue(record.Region),
        },
        {
          label: '服务版本',
          value: strToJson<Record<string, string>>(record.GosParams || '')
            ?.GameServiceVersion,
        },
        {
          label: '创建人',
          value: getUserNameBySite(record.FounderID, site) || '--',
        },
        {
          label: '创建时间',
          value: getLocalTime(
            record.CreateTime,
            userInfo?.UserSettings?.Timezone
          ),
        },
        {
          label: '所属工作室-游戏',
          value: [gameInfo.studioInfo?.Name, gameInfo.Name].join('/'),
        },
        {
          label: 'Gate Address',
          value:
            strToJson<Record<string, string>>(record.GosParams || '')
              ?.GateAddress || '--',
        },
        {
          label: 'Realm URL',
          value:
            strToJson<Record<string, string>>(record.GosParams || '')
              ?.ReamURL || '--',
        },
        {
          label: 'Server URL',
          value:
            strToJson<Record<string, string>>(record.GosParams || '')
              ?.BianQueAddr || '--',
        },
      ],
    },
    {
      label: '已开通服务',
      customRender: () => {
        return (
          <SubServiceChoose
            services={uniqBy(record.services, 'ServiceName')}
            gameID={record.GameID}
            envID={record.id}
            onChange={onChange}
          />
        );
      },
    },
  ]);
};
